






























import Vue, { PropType } from 'vue';

export type DataType = {
  innerValue: string;
}

export default Vue.extend({
  name: 'GTextareaFormInput',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    valid: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    itemName: { type: String as PropType<string> },
    value: { type: String as PropType<string> },
    rows: { type: Number as PropType<number> },
    name: { type: String as PropType<string> },
    placeholder: { type: String as PropType<string> },
    disabled: { type: Boolean as PropType<boolean> },
    maxLength: { type: Number as PropType<number> },
    isRequired: { type: Boolean as PropType<boolean> },
    underline: { type: Boolean as PropType<boolean>, default: false },
    error: { type: Array as PropType<string[]>, default: () => [] },
  },
  data(): DataType {
    return {
      innerValue: this.value,
    };
  },
  watch: {
    innerValue(val: string) {
      this.$emit('input', val);
    },
  },
});
